import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';

import Config from '../../config';
import { HelmetProvider } from 'react-helmet-async';
import SEO from '../../components/SEO';
import PageLoader from "../../components/PageLoader";
import NationalParkItems from './NationalParkItems';
import NationalParksMap from './NationalParksMap';

import { FaRegMeh } from 'react-icons/fa'

import('./style.css');

const STATE_CODE_MAP = {
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'FL': 'Florida',
    'GA': 'Georgia',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming'
}

const EmptyPage = () => {
    return <div className="empty-national-parks">
        <FaRegMeh size={120} color={'#71b46a'} />
        <h2>Looks like there are no national parks here!</h2>
        <a className="btn btn-green" href="/">Home</a>
    </div>
}

const NationalParks = ({ }) => {
    const { state } = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [mapPosition, setMapPosition] = useState("top");
    const [selected, setSelected] = useState(null);

    const handleScroll = () => {
        const position = window.pageYOffset;

        const headerHeight = document.getElementsByTagName('nav')[0].scrollHeight - 1;

        var body = document.body,
            html = document.documentElement;

        var bodyHeight = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);

        var parentHeight = document.getElementsByTagName('nav')[0].scrollHeight +
            document.getElementById('national-parks-container').getBoundingClientRect().height + 19 -
            headerHeight;

        var top = position - headerHeight;

        if (top < 0) {
            //setMapPos(0);
            setMapPosition("top");
            if (top + window.innerHeight > parentHeight) {
                setMapPosition("top-bottom");
            }
        } else if (top + window.innerHeight > parentHeight) {
            //setMapPos(parentHeight - window.innerHeight);
            setMapPosition("bottom");
        } else {
            //setMapPos(top)
            setMapPosition("middle");
        }
    };

    useEffect(() => {
        handleScroll();
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('resize', handleScroll);
        }
    }, []);

    useEffect(() => {
        const fetchNationalParks = () => {
            setLoading(true);
            axios.get(`${Config.AppPath}api/v1/national_parks/${state}.json`).then(res => {
                setData(res.data.national_parks);
                setLoading(false);
            }).catch(err => {
                setData([]);
                setLoading(false);
            })
        };
        fetchNationalParks();
    }, [])

    return (
      <>
            {loading && <PageLoader />}
            {data?.length === 0 ? <EmptyPage /> : <>
                <h1 className='national-parks-heading'>{`${STATE_CODE_MAP[state.toUpperCase()]} National Parks`}</h1>
                <h4 className='national-parks-heading-desc'>{`${data?.length || 0} places`}</h4>
                <div className='national-parks-wrapper'>
                    <Row style={{ display: "flex", margin: "0px" }}>
                        <Col className="col-xs-12" lg={5} md={7} sm={12} style={{ padding: "0px" }}>
                            <NationalParkItems data={data || []} selected={selected} setSelected={setSelected} />
                        </Col>
                        <Col className="hidden-sm hidden-xs" lg={7} md={5} style={{ padding: "0px" }}>
                            <NationalParksMap data={data} position={mapPosition} {...(selected !== null && data ? {
                                zoom: 8,
                                center: {
                                    lat: parseFloat(data[selected].latitude),
                                    lng: parseFloat(data[selected].longitude),
                                }
                            } : {})} />
                        </Col>
                    </Row>
                </div>
            </>}
      </>
    );
}

export default NationalParks;